<template>
  <div>
    <div class="header">
      <div class="headerInfo">
        <p class="temperature">10°/23° <span class="weather">晴朗</span></p>
        <div class="location">
          <img class="locationIcon" src="../assets/images/icon_location.png" alt="" />
          <p v-if="mode == 'enterprise'" class="locationName">{{ info.address }}</p>
          <p v-else class="locationName">
            {{ standard.province }}{{ standard.city }}{{ standard.district
            }}{{ standard.town }}
          </p>
          <img @click="copyText(info.address)" class="copyIcon" src="../assets/images/icon_copy.png" alt=""
            v-if="mode == 'enterprise'" />
          <img @click="
            copyText(
              `${standard.province}${standard.city}${standard.district}${standard.town}`
            )
            " class="copyIcon" src="../assets/images/icon_copy.png" alt="" v-else />
        </div>
      </div>
      <!-- end of header info -->
      <!-- start of banner. -->
      <div v-if="mode == 'enterprise' && info.rotation_chart && info.rotation_chart.length" class="bannerWrapper">
        <el-carousel height="150px">
          <el-carousel-item v-for="(bannerItemUrl, index) in info.rotation_chart" :key="index">
            <img class="bannerImage" :src="bannerItemUrl" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div v-else-if="mode == 'standard' &&
            standard.rotation_chart_array &&
            standard.rotation_chart_array.length
            " class="bannerWrapper">
        <el-carousel height="150px">
          <el-carousel-item v-for="(bannerItemUrl, index) in standard.rotation_chart_array" :key="index">
            <img class="bannerImage" :src="bannerItemUrl" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- end of header -->
    <!-- start of main content card. -->
    <div class="mainContentCard">
      <div class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_shield.png" alt="" class="propIcon" />
          <p class="propName">行政管辖</p>
        </div>
        <div type="text" class="propInput">
          {{ standard.province }}{{ standard.city }}{{ standard.district
          }}{{ standard.town }}
        </div>
      </div>
      <!--  -->
      <div v-if="mode == 'enterprise'" class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_tag.png" alt="" class="propIcon" />
          <p class="propName">企业名称</p>
        </div>
        <div type="text" class="propInput">{{ info.title }}</div>
      </div>
      <!--  -->
      <div class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_address.png" alt="" class="propIcon" />
          <p class="propName">详细地址</p>
        </div>
        <a type="text" class="propInput">
          {{ standard.street }}-{{ standard.community }}-{{ standard.building }}号楼{{
            standard.unit_floor
          }}单元{{ standard.room_number }}
        </a>
        <svg viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
          class="rightArrow">
          <path
            d="M317.846769 957.296943c6.289728 0 12.576383-2.398963 17.376358-7.19689l392.936471-392.937495c25.550034-25.550034 25.550034-67.121826 0-92.671861-0.12389-0.12389-0.249828-0.246756-0.375766-0.367575l-407.301582-390.221127c-9.799606-9.388005-25.355496-9.056266-34.744525 0.744365s-9.056266 25.355496 0.744365 34.744525l407.071208 389.999968c3.002032 3.076775 4.652535 7.130337 4.652535 11.436799 0 4.375062-1.704769 8.490057-4.798951 11.583215l-392.936471 392.936471c-9.595853 9.596877-9.595853 25.154815 0 34.751692C305.268338 954.896956 311.559089 957.296943 317.846769 957.296943z"
            fill="#999999"></path>
        </svg>
      </div>
      <!--  -->
      <div class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_code.png" alt="" class="propIcon" />
          <p class="propName">地址编码</p>
        </div>
        <div v-if="mode == 'enterprise'" type="text" class="propInput">
          {{ info.address_code }}
        </div>
        <div v-else type="text" class="propInput">{{ standard.address_code }}</div>
      </div>
      <!--  -->
      <div class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_house.png" alt="" class="propIcon" />
          <p class="propName">房屋编码</p>
        </div>
        <div v-if="mode == 'enterprise'" type="text" class="propInput">
          {{ info.house_code }}
        </div>
        <div v-else type="text" class="propInput">{{ standard.house_code }}</div>
      </div>
      <!--  -->
      <div class="propContainer">
        <div class="propHeader">
          <img src="../assets/images/icon_qrCode.png" alt="" class="propIcon" />
          <p class="propName">门牌楼二维码</p>
        </div>
        <el-image style="width: 25px; height: 25px; margin-right: 25px"
          :src="mode == 'enterprise' ? info.qrcode : standard.qrcode"
          :preview-src-list="[mode == 'enterprise' ? info.qrcode : standard.qrcode]"></el-image>
        <!--  -->
        <svg viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
          class="rightArrow">
          <path
            d="M317.846769 957.296943c6.289728 0 12.576383-2.398963 17.376358-7.19689l392.936471-392.937495c25.550034-25.550034 25.550034-67.121826 0-92.671861-0.12389-0.12389-0.249828-0.246756-0.375766-0.367575l-407.301582-390.221127c-9.799606-9.388005-25.355496-9.056266-34.744525 0.744365s-9.056266 25.355496 0.744365 34.744525l407.071208 389.999968c3.002032 3.076775 4.652535 7.130337 4.652535 11.436799 0 4.375062-1.704769 8.490057-4.798951 11.583215l-392.936471 392.936471c-9.595853 9.596877-9.595853 25.154815 0 34.751692C305.268338 954.896956 311.559089 957.296943 317.846769 957.296943z"
            fill="#999999"></path>
        </svg>
      </div>
      <!--  -->
      <div class="serviceContainer">
        <div class="serviceInnerContianer">
          <div class="propHeader">
            <img src="../assets/images/icon_user_service.png" alt="" class="propIcon" />
            <p class="serviceInnerPropName">起步区政务服务大厅电话</p>
          </div>
          <div type="text" class="serviceInnerPropInput"></div>
        </div>
        <!-- end of top-part -->
        <!-- start of bottom-part -->
        <div class="serviceBottomPart">
          <p class="serviceContent">服务热线 {{ standard.gov_service_hall_phone }}</p>
          <div class="serviceCall">
            <svg viewBox="0 0 1024 1024" s version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="30"
              class="phoneSvg">
              <path
                d="M661.333333 42.666667H320c-58.88 0-106.666667 47.786667-106.666667 106.666666v725.333334c0 58.88 47.786667 106.666667 106.666667 106.666666h341.333333c58.88 0 106.666667-47.786667 106.666667-106.666666V149.333333c0-58.88-47.786667-106.666667-106.666667-106.666666z m-170.666666 896c-35.413333 0-64-28.586667-64-64s28.586667-64 64-64 64 28.586667 64 64-28.586667 64-64 64z m192-170.666667H298.666667V170.666667h384v597.333333z"
                fill="#1b7fec"></path>
            </svg>
            <a :href="`tel:${standard.gov_service_hall_phone}`" class="serviceCallText">一键拨号</a>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="serviceContainer">
        <div class="serviceInnerContianer">
          <div class="propHeader">
            <img src="../assets/images/icon_user_service.png" alt="" class="propIcon" />
            <p class="serviceInnerPropName">网格员电话</p>
          </div>
          <div type="text" class="serviceInnerPropInput">{{ standard.community }}</div>
        </div>
        <!-- end of top-part -->
        <!-- start of bottom-part -->
        <div class="serviceBottomPart">
          <p class="serviceContent">
            {{ standard.grid_staff_name }} {{ standard.grid_staff_phone }}
          </p>
          <div class="serviceCall">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="30"
              class="phoneSvg">
              <path
                d="M661.333333 42.666667H320c-58.88 0-106.666667 47.786667-106.666667 106.666666v725.333334c0 58.88 47.786667 106.666667 106.666667 106.666666h341.333333c58.88 0 106.666667-47.786667 106.666667-106.666666V149.333333c0-58.88-47.786667-106.666667-106.666667-106.666666z m-170.666666 896c-35.413333 0-64-28.586667-64-64s28.586667-64 64-64 64 28.586667 64 64-28.586667 64-64 64z m192-170.666667H298.666667V170.666667h384v597.333333z"
                fill="#1b7fec"></path>
            </svg>
            <a :href="`tel:${standard.grid_staff_phone}`" class="serviceCallText">一键拨号</a>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="serviceContainer" style="border-bottom: none">
        <div class="serviceInnerContianer">
          <div class="propHeader">
            <img src="../assets/images/icon_user_service.png" alt="" class="propIcon" />
            <p class="serviceInnerPropName">派出所电话</p>
          </div>
          <div type="text" class="serviceInnerPropInput">{{ standard.town }}</div>
        </div>
        <!-- end of top-part -->
        <!-- start of bottom-part -->
        <div class="serviceBottomPart">
          <p class="serviceContent">
            {{ standard.police_name }} {{ standard.police_phone }}
          </p>
          <div class="serviceCall">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="30"
              class="phoneSvg">
              <path
                d="M661.333333 42.666667H320c-58.88 0-106.666667 47.786667-106.666667 106.666666v725.333334c0 58.88 47.786667 106.666667 106.666667 106.666666h341.333333c58.88 0 106.666667-47.786667 106.666667-106.666666V149.333333c0-58.88-47.786667-106.666667-106.666667-106.666666z m-170.666666 896c-35.413333 0-64-28.586667-64-64s28.586667-64 64-64 64 28.586667 64 64-28.586667 64-64 64z m192-170.666667H298.666667V170.666667h384v597.333333z"
                fill="#1b7fec"></path>
            </svg>
            <a :href="`tel:${standard.police_phone}`" class="serviceCallText">一键拨号</a>
          </div>
        </div>
      </div>
      <!-- end of service container. -->
      <div class="bottomButton">
        <div @click="toMemberLogin" class="buttonBase leftButton">标准地址库信息完善</div>
        <div @click="toIndex" class="buttonBase rightButton">齐心办掌上政务平台</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "indexWrapper",
  data() {
    return {
      info: {},
      standard: {},
      userInfo: {},
      previewImage: ["https://szmp.qilushop.cn/previewQrCode.png"],
      mode: "",
      canEdit: false,
    };
  },
  async created() {
    const post = this.$post;
    const localStorageSet = window.localStorage.setItem.bind(window.localStorage);
    const localStorageGet = window.localStorage.getItem.bind(window.localStorage);
    const localStorageRemove = window.localStorage.removeItem.bind(window.localStorage);

    const url = window.location.href;
    const params = {};
    const regex = /[?&]([^=#]+)=([^&#]*)/g;

    let match;
    while ((match = regex.exec(url))) {
      params[match[1]] = match[2];
    }

    if (params["enterprise_id"]) {
      localStorageRemove("standardId");
    }

    if (params["standard_id"]) {
      localStorageRemove("enterpriseId");
    }

    const code = params["code"];
    const state = params["state"];
    const enterpriseId = params["enterprise_id"] || localStorageGet("enterpriseId");
    const standardId = params["standard_id"] || localStorageGet("standardId");

    // 如果url携带有code和state 则尝试登陆
    if (code && state) {
      const loginResponse = await post(
        `/addons/third/api/callback?platform=wechat&code=${code}&state=${state}`
      );

      if (loginResponse.code == 1) {
        // 全局缓存token
        localStorageSet("token", loginResponse.data.user.token);
        window.location = "https://szmp.qilushop.cn";
      } else {
        // 可能是重复登陆 先看看缓存里有没有token 有的话把页面参数去掉防止重复登陆
        if (localStorageGet("token")) {
          window.location = "https://szmp.qilushop.cn";
        } else {
          // 登陆失败
          this.$message.error({
            message: loginResponse.msg,
          });
        }
      }
    } else if (!(code && state) && !localStorageGet("token")) {
      this.$router.push("/userLogin");

      return;
    }
    // verify token end. now getting page-data.

    const payload = {
      id: enterpriseId || standardId,
    };

    if (enterpriseId) {
      // save to cache.
      this.mode = "enterprise";
      localStorageSet("enterpriseId", enterpriseId);
      localStorageRemove("standardId");
      post("/api/enterprise/detail", payload).then((res) => {
        const enterpriseData = res.data;
        this.info = enterpriseData;
        this.standard = enterpriseData.standard;
        this.canEdit = enterpriseData.is_edit == 1;
        console.log(enterpriseData.is_edit);
      });
    } else if (standardId) {
      // save to cache.
      this.mode = "standard";
      localStorageSet("standardId", standardId);
      localStorageRemove("enterpriseId");

      post("/api/standard_address/detail", payload).then((res) => {
        this.standard = res.data;
        this.$set(
          this.standard,
          "rotation_chart_array",
          (this.standard.rotation_chart || "").split(",").filter(Boolean)
        );
        this.canEdit = this.standard.is_edit == 1;
        console.log(this.standard);
      });
    } else {
      this.$router.push("/index");
      localStorageRemove("standardId");
      localStorageRemove("enterpriseId");
      return;
    }
    const userInfoRes = await post("/api/user/userinfo");
    window.localStorage.setItem(
      "userInfo",
      JSON.stringify(userInfoRes.msg /* 没写错 用户信息就是在.msg里 不在.data里 */)
    );
    this.userInfo = userInfoRes.msg;
  },
  methods: {
    toIndex() {
      this.$router.push("/index");
    },
    toMemberLogin() {
      const m = this.$message;
      const r = this.$router;


      if (!this.userInfo.id) {
        m.warning("请等待接口加载完成.");
        return;
      }

      const userBindMobile = this.userInfo.mobile;
      if (!userBindMobile) {
        r.push("/memberLogin");
      } else {
        if (this.canEdit) {
          r.push(this.mode == "enterprise" ? "/modifyIndex" : "/standardEdit");
        } else {
          m.warning("您不是该区域网格员,无法进行编辑");
        }
      }
    },
    // 服务器没有https环境 无法使用clipboard API. [navigator.clipboard == undefined]
    copyText(payload) {
      var textInput = document.createElement("input");
      textInput.setAttribute("type", "text");
      textInput.setAttribute("value", payload);
      document.body.appendChild(textInput);
      textInput.select();
      document.execCommand("copy");
      document.body.removeChild(textInput);

      this.$message.info("已复制到剪切板");
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 330px;
  background-image: url("../assets/images/header_background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #4178f9;
  box-sizing: border-box;
  padding: 15px;
}

.headerInfo {
  box-sizing: border-box;
  padding-top: 30px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  color: white;
}

.temperature {
  font-weight: bold;
  font-size: 20px;
}

.weather {
  font-weight: normal;
  font-size: 18px;
}

.copyIcon {
  height: 24px;
  width: 24px;
}

.location {
  display: flex;
  align-items: center;
}

.locationName {
  margin: 0 8px;
  font-size: 18px;
  font-weight: bold;
  color: white;
}

.locationIcon {
  height: 30px;
  width: 25px;
}

.bannerWrapper {
  width: 100%;
  margin-top: 30px;
}

.bannerImage {
  width: 100%;
  height: 100%;
}

.mainContentCard {
  position: relative;
  bottom: 20px;
  width: 100%;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  box-sizing: border-box;
  padding: 10px;
  background-color: white;
}

.propContainer {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #c5c5c5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.propContainer:last-child {
  border-bottom: none;
}

.propHeader {
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center;
}

.propIcon {
  height: 50px;
  width: 50px;
}

.propName {
  width: calc(100% - 50px);
  color: #999999;
  font-size: 15px;
}

.propInput {
  width: 60%;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding-right: 20px;
  text-align: right;
  text-decoration: none;
}

.serviceInnerPropInput {
  width: 60%;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding-right: 10px;
  text-align: right;
}

.rightArrow {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.qrCodeSvg {
  margin-right: 20px;
}

.serviceContainer {
  width: 100%;
  border-bottom: 1px solid #c5c5c5;
  box-sizing: border-box;
  padding: 10px 0;
}

.serviceInnerContianer {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.serviceBottomPart {
  width: 100%;
  box-sizing: border-box;
  /* icon size. */
  padding-left: 50px;
  /* container padding. */
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.serviceCall {
  display: flex;
  align-items: center;
}

.serviceContent {
  margin: 0;
  font-size: 15px;
}

.serviceCallText {
  color: #1b7fec;
  font-size: 15px;
  text-decoration: none;
}

.serviceInnerPropName {
  color: #999999;
  font-size: 15px;
  white-space: nowrap;
}

.bottomButton {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.buttonBase {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: 48%;
  font-size: 15px;
}

.leftButton {
  background-color: #1b7fec;
}

.rightButton {
  background-color: #22d2ae;
}
</style>
